import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RedirectToDashboardOrLogin = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useSelector((state) => state.userLoaded);
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    // Prevent multiple redirects
    if (hasRedirected) return;
    
    // Don't redirect while loading
    if (loading) return;
    
    console.log('RedirectToDashboardOrLogin - isAuthenticated:', isAuthenticated, 'loading:', loading);
    
    if (isAuthenticated) {
      console.log('Redirecting to dashboard');
      setHasRedirected(true);
      navigate('/dashboard');
    } else {
      console.log('Redirecting to login');
      setHasRedirected(true);
      navigate('/login');
    }
  }, [isAuthenticated, loading, navigate, hasRedirected]);

  // Show loading while authentication state is being determined
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      <div>Redirecting...</div>
    </div>
  );
};

export default RedirectToDashboardOrLogin;